export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";